import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { ModificationSerializer36sautdazlmsc as ModificationSerializer } from './ModificationSerialization.mjs';
import { PairSerializerpzh6nuee9oov as PairSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tuples.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  And1a3dbpwh0hxmu as And,
  IfNotNullvieyp8szlv3m as IfNotNull,
  OnField2kq8b4gk936v8 as OnField,
  OnKey39cswdy1celtm as OnKey,
  SetAnyElements2se8zlywewplk as SetAnyElements,
  SetAllElementso97viygbubrg as SetAllElements,
  ListAnyElements3oaaxxe9tp3p5 as ListAnyElements,
  ListAllElements2qkljsceytb8 as ListAllElements,
  Notasovrzfq2v0i as Not,
  Or37bzl6q9twftg as Or,
} from './Condition.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  Nothing3qsizz6tw38jz as Nothing,
  IfIsType2q85mbl9d19gv as IfIsType,
  IfNotNull38wuwth0boumg as IfNotNull_0,
  Chain19a4phelb7wvt as Chain,
  ListPerElement3otxrneyl53yk as ListPerElement,
  SetPerElement2huwz2o9oppuj as SetPerElement,
  OnFielduegjwkreacmm as OnField_0,
} from './Modification.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  plus310ted5e4i90h as plus,
  take3onnpy6q7ctcz as take,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Mask', null, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('pairs', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_Mask_$serializer_me4g3t_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Mask_$serializer_b0tss7_k$();
      }
      static new_com_lightningkite_services_database_Mask_$serializer_b0tss7_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Mask', $this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('pairs', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_8g021a_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.pairs_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1))), value.pairs_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8g021a_k$(encoder, value instanceof Mask() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1))), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1))), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Mask().new_com_lightningkite_services_database_Mask_qvw6a8_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1)))];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_Mask_$serializer_me4g3t_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_Mask_$serializer_b0tss7_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var MaskClass;
function Mask() {
  if (MaskClass === VOID) {
    class $ {
      constructor(pairs) {
        Companion_getInstance();
        var tmp;
        if (pairs === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = pairs;
        }
        pairs = tmp;
        this.pairs_1 = pairs;
      }
      permitSort_dd32vb_k$(on) {
        var totalConditions = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = this.pairs_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var pair = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(on, Collection())) {
              tmp = on.isEmpty_y1axqb_k$();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s_0 = on.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s_0.next_20eer_k$();
              if (affects(pair.second_1, element.field_1)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          if (tmp$ret$0) {
            totalConditions.add_utx5q5_k$(pair.first_1);
          }
        }
        switch (totalConditions.get_size_woubt6_k$()) {
          case 0:
            return Always_getInstance();
          case 1:
            return totalConditions.get_c1px32_k$(0);
          default:
            return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(totalConditions);
        }
      }
      toString() {
        return 'Mask(pairs=' + toString(this.pairs_1) + ')';
      }
      hashCode() {
        return hashCode(this.pairs_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Mask()))
          return false;
        if (!equals(this.pairs_1, other.pairs_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Mask_qvw6a8_k$(seen0, pairs, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.pairs_1 = emptyList();
        } else
          $this.pairs_1 = pairs;
        return $this;
      }
    }
    initMetadataForClass($, 'Mask', Mask, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    MaskClass = $;
  }
  return MaskClass;
}
function affectsPaths(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof OnField_0()) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = affectsPaths(_this__u8e3s4.modification_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$2 = plus(listOf(_this__u8e3s4.key_1), item);
      destination.add_utx5q5_k$(tmp$ret$2);
    }
    tmp = destination;
  } else {
    if (_this__u8e3s4 instanceof SetPerElement()) {
      tmp = affectsPaths(_this__u8e3s4.modification_1);
    } else {
      if (_this__u8e3s4 instanceof ListPerElement()) {
        tmp = affectsPaths(_this__u8e3s4.modification_1);
      } else {
        if (_this__u8e3s4 instanceof Chain()) {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = _this__u8e3s4.modifications_1;
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s_0.next_20eer_k$();
            var list = affectsPaths(element);
            addAll(destination_0, list);
          }
          tmp = destination_0;
        } else {
          if (_this__u8e3s4 instanceof IfNotNull_0()) {
            tmp = affectsPaths(_this__u8e3s4.modification_1);
          } else {
            if (_this__u8e3s4 instanceof IfIsType()) {
              tmp = affectsPaths(_this__u8e3s4.modification_1);
            } else {
              if (_this__u8e3s4 instanceof Nothing()) {
                tmp = emptyList();
              } else {
                tmp = listOf(emptyList());
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function affects(_this__u8e3s4, path) {
  return affects_0(_this__u8e3s4, path.get_properties_zhllqc_k$());
}
function affects_0(_this__u8e3s4, list) {
  var tmp0 = affectsPaths(_this__u8e3s4);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (equals(take(element, list.get_size_woubt6_k$()), take(list, element.get_size_woubt6_k$()))) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function walk(_this__u8e3s4, action) {
  action(_this__u8e3s4);
  if (_this__u8e3s4 instanceof And()) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = _this__u8e3s4.conditions_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      walk(element, action);
    }
  } else {
    if (_this__u8e3s4 instanceof Or()) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = _this__u8e3s4.conditions_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        walk(element_0, action);
      }
    } else {
      if (_this__u8e3s4 instanceof Not()) {
        walk(_this__u8e3s4.condition_1, action);
      } else {
        if (_this__u8e3s4 instanceof ListAllElements()) {
          walk(_this__u8e3s4.condition_1, action);
        } else {
          if (_this__u8e3s4 instanceof ListAnyElements()) {
            walk(_this__u8e3s4.condition_1, action);
          } else {
            if (_this__u8e3s4 instanceof SetAllElements()) {
              walk(_this__u8e3s4.condition_1, action);
            } else {
              if (_this__u8e3s4 instanceof SetAnyElements()) {
                walk(_this__u8e3s4.condition_1, action);
              } else {
                if (_this__u8e3s4 instanceof OnKey()) {
                  walk(_this__u8e3s4.condition_1, action);
                } else {
                  if (_this__u8e3s4 instanceof OnField()) {
                    walk(_this__u8e3s4.condition_1, action);
                  } else {
                    if (_this__u8e3s4 instanceof IfNotNull()) {
                      walk(_this__u8e3s4.condition_1, action);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
//region block: exports
export {
  $serializer as $serializer3h4o01siqyg1z,
  Mask as Mask37ta2qlh32220,
  walk as walkwb3tmcr46qgj,
  Companion_getInstance as Companion_getInstancefutwz1zk5x6k,
};
//endregion

//# sourceMappingURL=Mask.mjs.map
